import type { Arealplan } from '@origo/planregister';
import type { PlanInfoFormValues } from '../types';
import { parseIsoDate, toIsoDate } from './toProcessings';

export function toPlanInfoFormValues(plan: Arealplan): PlanInfoFormValues {
    return {
        plannavn: plan.plannavn,
        plantype: plan.plantype,
        planstatus: plan.planstatus,
        lovreferanse: plan.lovreferanse,
        // Domain har ikke `beskrivelse` — feltet i UI er informativt for nå.
        beskrivelse: '',
        saksnummer: plan.saksnummer ?? '',
        forslagsstillerType: plan.forslagsstillerType ?? '',
        ubehandletKlage: plan.ubehandletKlage,
        ubehandletInnsigelse: plan.ubehandletInnsigelse,
        planbestemmelser: plan.planbestemmelser,
        vedtaksdato: toIsoDate(plan.vedtaksdato),
        vedtakEndeligPlanDato: toIsoDate(plan.vedtakEndeligPlanDato),
        ikrafttredelsesdato: toIsoDate(plan.ikrafttredelsesdato),
        kunngjoringsdato: toIsoDate(plan.kunngjoringsdato),
    };
}

/**
 * Datoen fra skjemaet, eller den lagrede datoen når brukeren ikke har endret
 * den. Lagrede datoer har ikke alltid UTC-midnatt (f.eks. norsk midnatt), og
 * en tur via `yyyy-mm-dd` ville da flyttet dem én dag.
 */
function fraDatofelt(lagret: Date | undefined, value: string): Date | undefined {
    return value === toIsoDate(lagret) ? lagret : parseIsoDate(value);
}

/** Skjema → oppdatert plan. Identifikatorer og øvrige felter bevares fra `plan`. */
export function applyPlanInfoFormToArealplan(plan: Arealplan, values: PlanInfoFormValues): Arealplan {
    return {
        ...plan,
        plannavn: values.plannavn,
        plantype: values.plantype as Arealplan['plantype'],
        planstatus: values.planstatus as Arealplan['planstatus'],
        lovreferanse: values.lovreferanse as Arealplan['lovreferanse'],
        // Et manglende saksnummer vises som '' og skal ikke telle som endret.
        saksnummer: values.saksnummer === (plan.saksnummer ?? '') ? plan.saksnummer : values.saksnummer,
        forslagsstillerType: (values.forslagsstillerType || undefined) as Arealplan['forslagsstillerType'],
        ubehandletKlage: values.ubehandletKlage,
        ubehandletInnsigelse: values.ubehandletInnsigelse,
        planbestemmelser: values.planbestemmelser,
        vedtaksdato: fraDatofelt(plan.vedtaksdato, values.vedtaksdato),
        vedtakEndeligPlanDato: fraDatofelt(plan.vedtakEndeligPlanDato, values.vedtakEndeligPlanDato),
        ikrafttredelsesdato: fraDatofelt(plan.ikrafttredelsesdato, values.ikrafttredelsesdato),
        kunngjoringsdato: fraDatofelt(plan.kunngjoringsdato, values.kunngjoringsdato),
        // beskrivelse droppes — ikke i domain.
    };
}
